var quote = "";
var author = ""
if(window.location.href.includes('/product') && jQuery('.product__testimonial').length == 0){
  jQuery(document).ready(function(){
    
var urb = window.location.href;
if(urb.includes('/calming-dog-bed') || urb.includes('/calming-bed')){
 quote = "Purchased for my highly anxious girl. She loved it straight away. Don't think I have ever seen her so relaxed";
 author = "Michelle Casey";  
}
    
else if(urb.includes('/premium-dog-car-bed')){
 quote = "Quality Dog Car Bed. Peace of mind my dog is safe when travelling in the car. So impressed I bought another one for my parents dog.";
 author = "Melanie Banks";    
}
    
else if(urb.includes('/deluxe-dog-couch-cover-bed')){
 quote = "Our dog loves it, the higher rests he pops his head on to sleep. Great size for our pug";
 author = "Siobhan Vescio";    
}
    
else if(urb.includes('/boucle-luxury-comforting-bed') || ur.includes('luxury-boucle-dog-bed-bundle') || ur.includes('boucle-car-bed-bundle') || ur.includes('luxury-boucle-dog-bed-dog-bed-bundle')
       || ur.includes('boucle')){
  if(!ur.includes('calming-boucle')){
 quote = "These beds are incredible! The colour suits my home perfectly and they are so sturdy and supportive. Excellent quality!";
 author = "Morgan Beattie";    
  }
}
    
else if(urb.includes('/premium-teddy-bed')){
 quote = "Charlie loves his bed and loves sleeping at night now! Helped him transition from our bed to his own!";
 author = "Chris Powell";    
}
    
else if(urb.includes('/premium-marble-dog-bowl')){
 quote = "Very stylish and functional. We love it and the dogs seem to too.";
 author = "Annabel Osborn Brodie";    
}
    
else if(urb.includes('/double-weighted-luxury-blanket')){
 quote = "Our girl loves to snuggle and hates the cold so this blanket was always going to be a winner, but is even better than what was promised!";
 author = "Nicole Foster";    
}
    
else if(urb.includes('/deluxe-dog-throw')){
 quote = "Absolutely thrilled with the throw, beautiful fabric and colour is perfect. They do not look like they are for our dog but he loves it xx";
 author = "Tracey Beacroft";    
}    
console.log("quote" + quote);
if(quote != "")   {
  

jQuery('h1.h2.product-single__title').eq(0).after(jQuery(`<div class="product__testimonial boom__testimonial---desktop">
                    <div class="testimonial_quote">
                        <p>“`+quote+`”</p>
                    </div>
              <div class="testimonial_author">
                        <p>`+author+`</p>
                    </div></div>`))
}
jQuery('.sash-badges-outer-container').eq(0).after(jQuery(`<div class="boom__product-form--disclaimer">
            <div class="disclaimer--toggle">
                <strong>100% No-Risk Money Back Guarantee</strong>
                <div class="action">
                    <svg class="plus" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 10">
                        <path d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                    </svg>
                    <svg class="minus" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 2">
                        <path d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>
            <div class="disclaimer--content">
                <p>We think you’re going to love your Sash products! But if you aren’t completely satisfied with anything, you can return or exchange the item(s) within 14 days of receiving your product.</p>
                <p><a href="https://www.sashbeds.com/pages/faqs">You can see all the details about our return policy here.</a> More questions? Just reach out—<a href="https://www.sashbeds.com/pages/contact-us">our customer service team</a> is happy to help!</p>
            </div>
        </div>`));
    
    jQuery('.boom__product-form--disclaimer').eq(0).after(jQuery(`.sash-subb`).eq(0));
    
 jQuery(document).ready(function(){
jQuery('.disclaimer--toggle').click(function(){
  jQuery(this).toggleClass('open');
}); 
}); 

});
}
